var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('use',_vm._b({},'use',{'xlink:href':'/svg/sprite.svg#' + _vm.name},false))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }